module.exports = __webpack_public_path__ + "img/pattern.d93e8384.png";